import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../../../components/Modal/Modal'
import { Button } from '../../../../components/Button/Button'
import { useUpdateAccountMutation } from '../../../../store/accountUserSettings/accountUserSettings'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAccount } from '../../../../common/useAccount'

type DisableLanguageSettingModalProps = {
  onHide: () => void
  onDisableClicked: () => void
}

export const DisableLanguageSettingModal: React.FC<DisableLanguageSettingModalProps> = ({ onHide, onDisableClicked }) => {
  const modalHeader = <h4 className='mb-3'>Disable multi language support</h4>
  const accountId = useAppSelector(selectAccountId)
  const { account, isFetching: isAccountFetching } = useAccount({ refetchOnMountOrArgChange: true })
  const [updateAccount, { isLoading: isAccountLoading }] = useUpdateAccountMutation()

  const disableMultiLanguage = () => {
    if (!account) {
      return
    }
    const accountConfig = {
      ...account.config,
      multiLanguageSupport: { ...account.config?.multiLanguageSupport, enabled: false },
    }
    updateAccount({
      accountId: accountId,
      payload: {
        config: accountConfig,
      },
    }).then(() => {
      onDisableClicked()
    })
  }

  const body = (
    <Container>
      <Row>
        <Col>
          <div className='pb-3'>
            By disabling multi language support, meeting language settings will be reset and all <strong>upcoming meetings will be processed in English</strong>
            .
          </div>
          <div className='d-flex gap-3 justify-content-end py-3'>
            <Button variant='secondary' onClick={onHide}>
              Cancel
            </Button>
            <Button variant='primary' onClick={disableMultiLanguage} loading={isAccountFetching || isAccountLoading}>
              Disable
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  )
  return <Modal show header={modalHeader} body={body} backdrop='static' keyboard={false} />
}
